import { useEffect, useState } from 'react';
import axios from 'axios';
import NewsletterSignup from '@/components/NewsletterSignup';
import { Hero } from '@/components/home/Hero';
import { About } from '@/components/home/About';
import { Visuals } from '@/components/home/Visuals';
import { TourPreview } from '@/components/home/TourPreview';
import { MerchPreview } from '@/components/home/MerchPreview';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomePage() {
    const [tourDates, setTourDates] = useState([]);
    const [products, setProducts] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [toursRes, productsRes] = await Promise.all([
                    axios.get(`${API}/tour-dates`),
                    axios.get(`${API}/products`)
                ]);
                setTourDates(toursRes.data.slice(0, 3));
                setProducts(productsRes.data.slice(0, 3));
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    return (
        <div data-testid="home-page" className="min-h-screen bg-brand-bg">
            <Hero />
            <About />
            <Visuals />
            <MerchPreview products={products} />
            <TourPreview tourDates={tourDates} />
            <NewsletterSignup />
        </div>
    );
}
